export * from './movedocs.component';
